// extracted by mini-css-extract-plugin
module.exports = {"header":"kz","blackNav":"kA","childrenFrame":"kB"};